import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M494.165333,640.333333 L215.765333,1531.10667 L317.632,1562.89333 L572.458667,747 L1783.76533,747 L1600.40533,1664.12 C1595.392,1688.97333 1573.41867,1707 1548.13867,1707 L159.978667,1707 C130.645333,1707 106.645333,1683.10667 106.645333,1653.66667 L106.645333,213.666667 L561.152,213.666667 L732.778667,427 L1493.312,427 L1493.312,533.666667 L1599.97867,533.666667 L1599.97867,320.333333 L783.872,320.333333 L612.138667,107 L-0.0213333333,107 L-0.0213333333,1653.66667 C-0.0213333333,1741.88 71.7653333,1813.66667 159.978667,1813.66667 L1548.13867,1813.66667 C1624.08533,1813.66667 1690.112,1759.58667 1705.04533,1685.02667 L1914.00533,640.333333 L494.165333,640.333333 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconOpenFolderLine = /*#__PURE__*/function (_Component) {
  _inherits(IconOpenFolderLine, _Component);

  var _super = _createSuper(IconOpenFolderLine);

  function IconOpenFolderLine() {
    _classCallCheck(this, IconOpenFolderLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconOpenFolderLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOpenFolder",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconOpenFolderLine.displayName = "IconOpenFolderLine";
  return IconOpenFolderLine;
}(Component);

IconOpenFolderLine.glyphName = 'open-folder';
IconOpenFolderLine.variant = 'Line';
IconOpenFolderLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOpenFolderLine;
export { IconOpenFolderLine };